import {TextLinkWidget} from '@tableau/widgets';
import React from 'react';

import {openReactActionDialog} from '~commonInfra/dialogs/ReactActionDialog';
import {TabDialogWidth} from '~commonInfra/dialogs/style/TabDialogWidth';
import {HelpService} from '~commonInfra/services/HelpService';
import {CommonStyles} from '~commonInfra/styles/CommonStyles';
import {Messages} from '~src/codegen/Localize';
import {
  KMS_IN_ONLINE_ENABLEMENT_INFO_LINK
} from '~src/settings/general-settings/components/sections/kms-in-online/KMSInOnlineSection';
import {learnMoreStyle} from '~src/settings/styles/CommonStyles';

/**
 * Generate dialog to ask user to confirm whether to generate a new encryption key and rotate the previous key
 */
export function keyRotationConfirmationDialog(): Promise<any> {
  return openReactActionDialog({
    dismissDialogOnActionFailed: false,
    initialBodyProps: undefined,
    initialDialogState: undefined,
    title: Messages.extractEncryptionTOLKeyRotationDialogPrompt(),
    bodyComponent: keyRotationConfirmationDialogBody,
    actionName: Messages.extractEncryptionTOLKeyRotationDialogConfirmation(),
    action: () => Promise.resolve(),
    dialogWidth: TabDialogWidth.width500px,
    showCloseButton: true,
  }).result;
}

function keyRotationConfirmationDialogBody(): JSX.Element {
  return <div style={{marginBottom: CommonStyles.Sizes.LargeSpace}}>
    {Messages.extractEncryptionTOLKeyRotationDialog()}
    <TextLinkWidget
      testId={KMS_IN_ONLINE_ENABLEMENT_INFO_LINK}
      href={HelpService.getServerHelpUrlByCategory('customer-managed-encryption-keys')}
      target="_blank"
      rel="noopener noreferrer"
      className={learnMoreStyle}
    >
      {Messages.learnMore()}
    </TextLinkWidget>
  </div>;
}